<div class="w-full">
    <app-select [(value)]="selectedModel" [options]="modelOptions()" [config]="selectConfig()"
        [itemTemplate]="itemTemplate" [selectedItemTemplate]="selectedItemTemplate"
        (onChange)="onModelChange($event)" />

    <ng-template #itemTemplate let-model>
        <div class="w-full cursor-pointer transition-all duration-200 rounded-xl" [ngClass]="{
                    'bg-gray-50 border border-gray-200': isModelSelected(model),
                    'hover:bg-gray-100': !isModelSelected(model)
                }">
            <div class="flex flex-col gap-1 p-2.5 w-full">
                <div class="flex items-center gap-2 w-full min-w-0">
                    <i [innerHTML]="model.icon | sanitizeHtml"></i>
                    <span class="font-medium text-sm text-gray-900 flex-1 min-w-0 truncate">{{ model.label }}</span>
                    <span *ngIf="model.model" class="text-sm text-gray-500 shrink-0">{{ model.model }}</span>
                </div>
                <span *ngIf="model.description" class="text-xs text-gray-500">{{ model.description }}</span>
            </div>
        </div>
    </ng-template>

    <ng-template #selectedItemTemplate let-model>
        <div *ngIf="model" class="flex items-center gap-2 border-none bg-transparent">
            <i [innerHTML]="model.icon | sanitizeHtml"></i>
            @if(!iconOnly()) {
            <span class="font-medium text-sm text-gray-900">{{ model.label }}</span>
            }
        </div>
    </ng-template>
</div>